import { BookmakerDictionaryItem } from '@/models/dictionary/bookmaker';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { IBookmakerDictionaryApi } from '@/types';

export const useBookmakerDictionary = defineStore('bookmakerDictionary', () => {
    const itemsAll = shallowRef<BookmakerDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(itemsAll);

    // actions
    function setData(data: IBookmakerDictionaryApi[]) {
        console.time('set-bookmaker-dictionary');
        itemsAll.value = data.map((item) => new BookmakerDictionaryItem(item));
        console.timeEnd('set-bookmaker-dictionary');
    }

    const items = computed(() => itemsAll.value);

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
